export default __webpack_public_path__ + "static/media/banner.40f8f064.png";